export const openCompareWidget = (e) => {
  e.stopPropagation();
  e.preventDefault();

  const compareWrapper = document.querySelector('.compare-communities');
  const compareOverlay = document.querySelector('.compare-overlay');

  if (compareWrapper && compareOverlay) {
    compareWrapper.classList.remove('collapsed');
    compareOverlay.classList.remove('collapsed');
    document.body.style.overflow = 'hidden';
  }
}


export const closeCompareWidget = (e) => {
  e.stopPropagation();
  e.preventDefault();

  const compareWrapper = document.querySelector('.compare-communities');
  const compareOverlay = document.querySelector('.compare-overlay');

  if (compareWrapper && compareOverlay) {
    compareWrapper.classList.add('collapsed');
    compareOverlay.classList.add('collapsed');
    document.body.style.overflow = null;
  }
};



// WEBPACK FOOTER //
// ./src/js/components/compare-community.js